// Module
var code = "<label>{{:: vm.label}}</label>\r\n<div class=\"mx-rating\" ng-class=\"{\r\n\t\t'mx-rating--disabled': vm._disabled,\r\n\t\t'mx-rating--read-only': vm.readOnly\r\n\t}\">\r\n</div>\r\n";
// Exports
export default code;